// Ported from LC2's AccountPerformance.js (commons/components/HomeTabs/Performance/) —
// same "just the concessions metric" composition. LC2 also had a commented-out
// `<Delinquency />` (Metrics/Delinquency.js) here — it's commented out in LC2 itself (not
// something this port disabled), so it's left out here too; see UnitsWithConcessions.js's
// header comment for the one active metric.
import React from 'react';
import {Stack} from '@mui/material';

import UnitsWithConcessions from './UnitsWithConcessions';

const AccountPerformance = () => (
    <Stack direction="column" rowGap={2} sx={{width: '100%'}}>
        <UnitsWithConcessions />
    </Stack>
);

export default AccountPerformance;
